<p class="tracking-number-link" (click)="openPackageDetails()">
  {{ trackingNumber }}
</p>
